import React from 'react';

import { Divider } from 'antd';

import useIsMobile from '@shared/hooks/useIsMobile';

import dayjs from 'dayjs';

import css from './styles.module.scss';

export const SchedulePopoverData = ({ t, event, currentUser }) => {
  const [isMobile] = useIsMobile(769);

  const timezoneOffset = currentUser
    ? currentUser.timezone.offset / 60 - (currentUser.domainCompany?.timezone?.offset / 60 || 0)
    : 0;

  const createEventRows = periods =>
    periods?.map((period, index) => {
      const { startTime, endTime, dates } = period;

      return dates?.map((dateItem, dateIndex) => {
        const correctedStartDateTime = dayjs(`${dateItem}T${startTime}`).add(timezoneOffset, 'h');
        const correctedEndDateTime = dayjs(`${dateItem}T${endTime}`).add(timezoneOffset, 'h');

        const formattedDate = correctedStartDateTime.format('DD.MM.YYYY');
        const formattedStartTime = correctedStartDateTime.format('HH:mm');
        const formattedEndTime = correctedEndDateTime.format('HH:mm');

        return (
          <div key={`schedule_${index}_${dateIndex}`} className={css['Details-schedule__schedule__row']}>
            <span>{formattedDate}</span>
            <span>{`${formattedStartTime} - ${formattedEndTime}`}</span>
          </div>
        );
      });
    });

  return (
    <div className={css['Details-schedule__schedule']}>
      <div className={css['Details-schedule__schedule__title']}>{t('scheduleEvents')}</div>
      {!isMobile ? (
        <>
          <div className={css['Details-schedule__schedule__header']}>
            <span>{t('date')}</span>
            <span>{t('time')}</span>
          </div>
          {createEventRows(event.periods)}
        </>
      ) : (
        <>
          <Divider className={css['Details-schedule__schedule__divider']} />
          {event.periods?.map((period, index) => {
            const { startTime, endTime, dates } = period;

            return dates?.map((dateItem, dateIndex) => {
              const correctedStartDateTime = dayjs(`${dateItem}T${startTime}`).add(timezoneOffset, 'h');
              const correctedEndDateTime = dayjs(`${dateItem}T${endTime}`).add(timezoneOffset, 'h');

              const formattedDate = correctedStartDateTime.format('DD.MM.YYYY');
              const formattedStartTime = correctedStartDateTime.format('HH:mm');
              const formattedEndTime = correctedEndDateTime.format('HH:mm');

              return (
                <div key={`mobile_schedule_${index}_${dateIndex}`}>
                  {/* Ячейка с датой */}
                  <div className={css['Details-schedule__schedule__header__cell']}>{t('date')}</div>
                  <div className={css['Details-schedule__schedule__cell']}>{formattedDate}</div>

                  {/* Ячейка с временем */}
                  <div className={css['Details-schedule__schedule__header__cell']}>{t('time')}</div>
                  <div className={css['Details-schedule__schedule__cell']}>
                    {`${formattedStartTime} - ${formattedEndTime}`}
                  </div>

                  <Divider className={css['Details-schedule__schedule__divider']} />
                </div>
              );
            });
          })}
        </>
      )}
    </div>
  );
};
